﻿
import { ioDatatypes } from "../../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter, ReactBootstrap, ReactLoader as Loader, Cookie } from "../../blib.js";

import * as xlib from "../../../../xlib/index.js";
import * as blib from "../../../../blib/index.js";


import { IndexRoute, Router, Route, Link } from "react-router";

///////////////////  APP FOLLOWING PATTERNS FROM: http://localhost:8080/auth-with-shared-root/   (react-router example)





//import Cookie = blib.Cookie;

//import xlib = refs.xlib;
// import _ = xlib.lodash;
// import __ = xlib.lolo;
var log = new xlib.diagnostics.logging.Logger( __filename );
xlib.diagnostics.logging.logPromiseUnhandledRejections();
//import jsHelper = xlib.jsHelper;

//import blib = refs.blib;


// import React = blib.React;
// import ReactDOM = blib.ReactDOM;
// import Redux = blib.Redux;
// import ReactRedux = blib.ReactRedux;
// import ReactRouter = blib.ReactRouter; //tested with 1.x, not sure if it works with 2.x
// import History = blib.History;
// import ReactBootstrap = blib.ReactBootstrap;
// import ReduxSimpleRouter = blib.ReduxSimpleRouter;

//import ioDatatypes = refs.ioDatatypes;


import * as commonComponents from "./commoncomponents.js";
import { errorPopupContent, SUPPORT_EMAIL } from "./error-popup.js";

import * as config from "../client-config.js";


//import Loader = blib.ReactLoader;


import * as login from "./login.js";

let Button = ReactBootstrap.Button;

import moment from "moment";
//import bluebird from "bluebird";
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////

export module reduxScafolding {
	//module ActionType {
	//    export const SET_ACCOUNTSTATE = "accountDetails.SET_ACCOUNTSTATE";
	//    export const SET_ORDERSTATE_OrderProcessingPromise = "accountDetails.SET_ORDERSTATE_OrderProcessingPromise";
	//}



	export interface IAccountState extends ioDatatypes.account.IAccountState {
	}

	export class IOrderState {
		orderProcessingPromise: bluebird<any> = bluebird.resolve();
		subscribeToPlan: ( newPlanId: string, pagesPerDayText: string, costText: string ) => Promise<any> = null;
		//oneTimePayment:(amount:number, pages)
	}


	export var action = {
		setAccountDetails( accountState: IAccountState ): blib.IActionAutoReducer<ReduxState> {
			log.assert( accountState != null );
			//return {
			//    type: ActionType.SET_ACCOUNTSTATE,
			//    value: _.clone(accountDetails),
			//};
			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setAccountDetails",
				debugValue: { accountState },
				reducer: ( newState ) => {
					newState.accountState = accountState;
					newState.isAccountDetailsOutOfDate = false;
					return newState;
				},
			};

			return toReturn;
		},

		setOrderProcessingPromise( orderProcessingPromise: PromiseLike<any> ): blib.IActionAutoReducer<ReduxState> {
			log.assert( orderProcessingPromise != null );
			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setOrderProcessingPromise",
				debugValue: { orderProcessingPromise },
				reducer: ( newState ) => {
					newState.orderState.orderProcessingPromise = bluebird.resolve( orderProcessingPromise );
					return newState;
				},
			};

			return toReturn;
		},
		setOrderProcessingSubscribeFunction( subscribeToPlan: ( newPlanId: string, pagesPerDayText: string, costText: string ) => Promise<any> ): blib.IActionAutoReducer<ReduxState> {
			log.assert( subscribeToPlan != null );
			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setOrderProcessingSubscribeFunction",
				debugValue: { subscribeToPlan },
				reducer: ( newState ) => {
					newState.orderState.subscribeToPlan = subscribeToPlan;
					return newState;
				},
			};

			return toReturn;
		},
		setIsAccountDetailsOutOfDate(): blib.IActionAutoReducer<ReduxState> {
			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setAccountDetailsOutOfDate",
				debugValue: {},
				reducer: ( newState ) => {
					newState.isAccountDetailsOutOfDate = true;
					return newState;
				},
			};

			return toReturn;
		},
		setBalance( newBalance: config.pjscGlobalConfig.sharedConfig.balance.IBalance ): blib.IActionAutoReducer<ReduxState> {
			log.assert( newBalance != null );
			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setBalance",
				debugValue: { newBalance },
				reducer: ( newState ) => {
					newState.balance = newBalance;
					newState.isBalanceOutOfDate = false;
					return newState;
				},
			};

			return toReturn;
		},

		setIsBalanceOutOfDate(): blib.IActionAutoReducer<ReduxState> {
			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setIsBalanceOutOfDate",
				debugValue: {},
				reducer: ( newState ) => {
					newState.isBalanceOutOfDate = true;
					return newState;
				},
			};

			return toReturn;
		},


		setEzCheckout( ezCheckout: commonComponents.StripeCheckout.EzStripeCheckout ): blib.IActionAutoReducer<ReduxState> {
			log.assert( ezCheckout != null );
			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setEzCheckout",
				debugValue: { ezCheckout },
				reducer: ( newState ) => {
					newState.ezCheckout = ezCheckout;
					return newState;
				},
			};

			return toReturn;
		},
	}
	export type Action = typeof action;



	export class ReduxState {
		accountState: IAccountState = null;
		orderState: IOrderState = new IOrderState();
		balance: config.pjscGlobalConfig.sharedConfig.balance.IBalance = null;
		isAccountDetailsOutOfDate = true;
		isBalanceOutOfDate = true;
		ezCheckout: commonComponents.StripeCheckout.EzStripeCheckout;
	}
	export const reduxStateKey = "accountDetails";

	//   const initialState: IReduxState = {
	//	accountState: null,
	//	orderState: { orderProcessingPromise: Promise.resolve() },
	//};
	//{
	//    userDetails: null,//{apiKey:null,email:null },
	//    billingDetails: null,//{canceledSubscriptionExpires:null,canceledSubscriptionId:null,cardOnFileDetails:null,cardOnFileId:null,currentSubscriptionId:null},
	//    currentPlan: null,
	//}
	export function reducer( state = new ReduxState(), action: blib.IActionAutoReducer<ReduxState> ) {
		//all reducers (in all modules) get called during init or when other module's invoke.  so need to filter our reducer to only actions we care about
		if ( action == null || action.reducer == null || action.type.indexOf( reduxStateKey ) != 0 ) {
			return state;
		}
		var newState = _.clone( state );
		//log.assert(false, { state, newState });
		return action.reducer( newState );

		//if (action.reducer != null) {
		//	return action.reducer(newState);
		//}

		//    switch (action.type) {
		//        case ActionType.SET_ACCOUNTSTATE:
		//newState.accountState = action.value;
		//            return newState;
		//        //newState = action.value;
		//        //return newState;
		//        //case ActionType.SET_CURRENTSUBSCRIPTION:
		//        //    newState.currentSubscription = action.value;
		//        //    return newState;
		//        //case ActionType.SET_USERDETAILS:
		//        //    newState.userDetails = action.value;
		//        //    return newState;
		//        default:
		//            return state;
		//    }

	}
}

//import Promise from "bluebird";
import bluebird from "bluebird"


export module components {


	class _UserDetails extends React.Component<reduxScafolding.Action & { accountDetails: reduxScafolding.ReduxState } & { pushPath: typeof ReduxSimpleRouter.pushPath },
		{ balance?: config.pjscGlobalConfig.sharedConfig.balance.IBalance, balanceForce?: config.pjscGlobalConfig.sharedConfig.balance.IBalance, btn_promise_refreshCreditBalance?: bluebird<any>, isKeyChangeRunning?: boolean }>{


		constructor( props: any ) {
			super( props );
			this.state = { btn_promise_refreshCreditBalance: bluebird.resolve() };
		}


		componentWillReceiveProps( nextProps: any ) {
			if ( ( nextProps.accountDetails as reduxScafolding.ReduxState ).isBalanceOutOfDate === true ) {
				log.info( "_UserDetails.componentWillReceiveProps() isBalanceOutOfDate==true, will _requestFromServerBalanceForce" );
				this._requestFromServerBalanceForce();
			}

		}



		componentWillMount() {

			//log.info("_UserDetails.componentWillMount", { accountState: this.props.accountDetails.accountState });
			if ( this.props.accountDetails != null && this.props.accountDetails.accountState != null && this.props.accountDetails.accountState.email != null ) {
				log.info( "user id emit", { userId: this.props.accountDetails.accountState.email } );
				blib.googleAnalytics( "set", "userId", this.props.accountDetails.accountState.email );
			}
			//	this._requestFromServerBalanceForce();
			//	//if (this.state.balance == null) {
			//	//	this._requestFromServerBalance()
			//	//		.then(this._requestFromServerBalanceForce.bind(this));
			//	//}

		}

		private _requestFromServerBalanceForce() { //: bluebird<any> {
			//log.debug("_AccountDetails.componentDidMount() props", this.props);
			//this.props.setBalance(null);
			var origin = window.location.origin;
			var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.balance_getBalanceForceRefresh;
			// posts no key: the server refreshes the login session's account (PjscApiKeys #202610291041_11)

			let toReturn = new bluebird<void>( ( resolve, reject ) => {
				xlib.net.axios.post<config.pjscGlobalConfig.sharedConfig.balance.IBalance>( target )
					.then( ( response ) => {
						var balanceForce = response.data;
						//log.info("._requestFromServer.responsePayload", response);
						this.props.setBalance( balanceForce );
						this.setState( { balanceForce } );//, () => { log.info("set balanceForce state finished"); });
						return resolve();
					} )
					.catch( ( err ) => {
						//this.setState({ requestErrorCount: this.state.requestErrorCount + 1 });
						log.info( "_UserDetails.balance_getBalanceForceRefresh.catch", err );
						//an _requestErrorCount >=2 causes warning message to be shown, see this._showAlertMessage()
						this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
						return resolve();
					} );
			} );
			//return new Promise<void>((resolve, reject) => {
			//	toReturn.then((resolveValue) => {
			//		log.info("promise RESOLVE", resolveValue);
			//		resolve();
			//	}, (rejectErr) => {

			//		log.info("promise rejectErr", rejectErr);
			//		reject(rejectErr);
			//	});
			//});
			return toReturn;// as Promise<any>;
		}
		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		private _openOutOfDateModal() {
			const content = errorPopupContent( "Page out of date", config.pjscGlobalConfig.sharedConfig.apiKeys.PAGE_OUT_OF_DATE );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		/** a key add/delete failure: 404 (route missing on an older server, or a key no longer on the account) -> reload modal; else the reply's text */
		private _openKeyChangeError( title: string, err: any ) {
			if ( err != null && err.response != null && err.response.status === 404 ) {
				return this._openOutOfDateModal();
			}
			const content = errorPopupContent( title, err );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		/** the account state with the key list a key add/delete replied */
		private _applyKeyList( apiKeys: string[] ) {
			this.props.setAccountDetails( { ...this.props.accountDetails.accountState, apiKeys } );
		}

		private _postKeyChange( route: string, payload: any, errorTitle: string ) {
			this.setState( { isKeyChangeRunning: true } );
			return xlib.net.axios.post<ioDatatypes.account.IApiKeysReply>( window.location.origin + route, payload )
				.then( ( response ) => {
					if ( response.data == null || !Array.isArray( response.data.apiKeys ) ) {
						this._openOutOfDateModal();
						return;
					}
					this._applyKeyList( response.data.apiKeys );
				} )
				.catch( ( err ) => {
					log.info( "_UserDetails._postKeyChange.catch", err );
					this._openKeyChangeError( errorTitle, err );
				} )
				.then( () => {
					this.setState( { isKeyChangeRunning: false } );
				} );
		}

		/** (+): add a key at once, no warning (PjscApiKeys #202610291041_3); limits are the server's refusals */
		private _btn_click_addKey() {
			blib.googleAnalytics( "send", "event", "btn_click_addApiKey", "click" );
			this._postKeyChange( config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_apiKeyAdd, {}, "Could not add an API key" );
		}

		/** (X): the last key -> error modal; else confirm with the propagation warning, then delete (PjscApiKeys #202610291041_2) */
		private _btn_click_deleteKey( apiKey: string ) {
			blib.googleAnalytics( "send", "event", "btn_click_deleteApiKey", "click" );
			const apiKeys = this.props.accountDetails.accountState.apiKeys || [];
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( apiKeys.length <= 1 ) {
				const content = errorPopupContent( "Could not delete the API key", config.pjscGlobalConfig.sharedConfig.apiKeys.REFUSAL_TEXT.lastKey );
				if ( modal != null ) {
					modal.ShowError( content );
				}
				return;
			}
			if ( modal == null ) {
				return;
			}
			const message = <span>Delete the API key <code>{ apiKey }</code>?</span>;
			modal.Show( "Delete API key", message, config.pjscGlobalConfig.sharedConfig.apiKeys.DELETE_WARNING, { confirmButtonText: "Delete" } )
				.then( () => {
					const payload = { apiKey };
					return this._postKeyChange( config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_apiKeyDelete, payload, "Could not delete the API key" );
				}, () => { /* cancelled */ } );
		}

		/** the key list: one line per active key, each in its own `<code>` with a red (X); a green (+) on the line below (PjscApiKeys #202610291041_1) */
		private _render_ApiKeys() {
			const accountState = this.props.accountDetails.accountState;
			if ( !Array.isArray( accountState.apiKeys ) ) {
				// an older server's reply: its single key, no controls, and the reload text
				return <p>ApiKey: <code>{ accountState.creditBalanceDetails.apiKey }</code> <span className="text-muted small">{ config.pjscGlobalConfig.sharedConfig.apiKeys.PAGE_OUT_OF_DATE }</span></p>;
			}
			const isBusy = this.state.isKeyChangeRunning === true;
			return (
				<div>
					<p>API Keys:</p>
					{ accountState.apiKeys.length === 0 ? <p className="text-muted small">Your API keys could not be read. Please reload the page.</p> : null }
					{ accountState.apiKeys.map( ( apiKey ) => (
						<p key={ apiKey }>
							<code>{ apiKey }</code>&nbsp;
							<button className="btn btn-link btn-sm" title="Delete this API key" aria-label="Delete this API key" disabled={ isBusy } onClick={ this._btn_click_deleteKey.bind( this, apiKey ) }>
								<span className="fa fa-times" style={ { color: "#d9534f" } }></span>
							</button>
						</p>
					) ) }
					<p>
						<button className="btn btn-link btn-sm" title="Add an API key" aria-label="Add an API key" disabled={ isBusy } onClick={ this._btn_click_addKey.bind( this ) }>
							<span className="fa fa-plus" style={ { color: "#5cb85c" } }></span>
						</button>
					</p>
				</div>
			);
		}

		private _render_UserDetails() {
			return (
				<section>
					<h4 className="card-title">User Details</h4>
					<div className="card-block card-text">
						<p>Email: <strong>{ this.props.accountDetails.accountState.email }</strong></p>
						{ this._render_ApiKeys() }
					</div>
				</section>
			);
		}

		private _btn_click_refreshCreditBalance() {
			log.info( "start click" );
			blib.googleAnalytics( "send", "event", "btn_click_refreshCreditBalance", "click" );
			let promiseResult = this._requestFromServerBalanceForce()
				.finally( () => {
					log.info( "start done promise" );

					setTimeout( () => {
						this.forceUpdate();
						//this.setState({ btn_promise_refreshCreditBalance: promiseResult });
					} );
				} );

			////set state after promise finishes to update UI
			//promiseResult.finally(() => {
			//	log.info("start done promise");
			//	//this.setState({ btn_promise_refreshCreditBalance: promiseResult }, () => { log.info("finish done promise setstate"); });
			//});
			//set state to update ui to show loading
			this.setState( { btn_promise_refreshCreditBalance: promiseResult } );
			log.info( "end click" );

		}
		private _render_CreditBalance() {
			if ( this.props.accountDetails.balance == null ) {
				return (
					<section>
						<h4 className="card-title">Credit Balance </h4>
						<div className="col-sm-12">
							<Loader loaded={ false } />
						</div>
					</section>
				);
			} else {


				let dailySubscriptionBalance = this.props.accountDetails.balance.dailySubscriptionBalance;//this.props.accountDetails.accountState.creditBalanceDetails.dailySubscriptionBalance;
				let dailySubscriptionMax = this._getDailySubscriptionMax();

				let dailySubscriptionBalancePages = ( dailySubscriptionBalance / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage );
				let creditBalanceMaxPages = ( dailySubscriptionMax / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage );

				let prepaidBalanceUsd = this.props.accountDetails.balance.prepaidBalance;//this.props.accountDetails.accountState.creditBalanceDetails.prepaidBalance;
				let prepaidBalancePages = prepaidBalanceUsd / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage;

				//<div className="alert alert-info"><strong>FREE USAGE</strong>:  While we are finishing the transition to the new account system, <strong>You will not be billed for usage.</strong>  That means PhantomJsCloud is free for the day or two!</div>
				return (
					<section>
						<h4 className="card-title">Credit Balance &nbsp;
							<button className="btn btn-secondary btn-sm" onClick={ this._btn_click_refreshCreditBalance.bind( this ) } disabled={ this.state.btn_promise_refreshCreditBalance.isResolved() !== true }  >
								<span className="fa fa-refresh"></span>
							</button>
						</h4>

						<Loader loaded={ this.state.btn_promise_refreshCreditBalance.isResolved() && this.props.accountDetails.isBalanceOutOfDate === false }></Loader>
						Total: <strong>{ __.format( dailySubscriptionBalance + prepaidBalanceUsd ) }</strong> <em className="text-muted small">(Daily Subscription + Prepaid) </em>
						<ul>
							<li className="list-group-item">

								<strong>Daily Subscription Credits</strong><span className="small text-muted"> (The <strong><em>{ this.props.accountDetails.accountState.currentPlan.name }</em></strong> Plan) </span>
								<br /><code>{ dailySubscriptionBalance.toFixed( 5 ) }</code><em className=""> (About { __.format( Math.round( dailySubscriptionBalancePages ) ) } Pages) </em>
								<br /><span className="text-muted small">Plan Maximum per Day: <strong>{ dailySubscriptionMax.toFixed( 5 ) }</strong>
									<em> (About { __.format( Math.round( creditBalanceMaxPages ) ) } Pages per Day) </em>
								</span>
							</li>
							<li className="list-group-item">
								<strong>Prepaid Credit</strong>
								<br /><code>${ prepaidBalanceUsd.toFixed( 5 ) }</code><em className=""> (About { __.format( Math.round( prepaidBalancePages ) ) } Pages) </em>
							</li>
						</ul>

						<div className="card-block card-text text-muted small">
							Changes to Credit Balance takes up to 5 minutes to propigate through the system.
							Daily Subscription Credits incrementally refills every hour based on your active Subscription Plan.
							If your 'Daily Subscription Credits Remaining' reaches zero your Prepaid Credit is used.
							All requests are billed based on processing time ({ config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.pricePerHour } Credits/Hour) and Data Egress ({ config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.pricePerGb } Credits/GB).
							Prepaid Credit never expires.

						</div>
						{this._render_TraceBalance() }
					</section>
				);
			}
		}
		render() {

			if ( this.props.accountDetails.accountState == null ) {
				return <pre>Requesting from server...</pre>;
			}

			return (
				<section>
					<commonComponents.EzModal ref="Modal" />

					<div className="col-md-6">
						{ this._render_UserDetails() }
					</div>

					<div className="col-md-6">
						{ this._render_CreditBalance() }
					</div>
				</section>
			);
		}

		private _render_TraceBalance() {
			if ( __.isTrace ) {
				return <div>
					<pre>{ __.JSONX.inspectStringify( this.state ) }</pre>
				</div>;

			} else {
				return null;
			}
		}


		//private _showAlertMessage() {


		//    if (this.state.requestErrorCount < 2) {
		//        return;
		//    } else {
		//        return (

		//            <div className="alert alert-danger">Unable to connect to server in last {this.state.requestErrorCount * this._requestIntervalSeconds} seconds.Balance not updated.</div>

		//        );
		//    }
		//}


		/**
		 *  if a currentSubscription is available, will show creditBalance per day.   blank otherwise.
		 */
		private _getDailySubscriptionMax() {

			//if (this.props.accountDetails.accountState == null) {
			//    return <pre>Requesting from server...</pre>;
			//}
			let subscriptionMonthlyEquivalent = parseFloat( this.props.accountDetails.accountState.currentPlan.metadata[ "monthlyEquivalent" ] );
			let subscriptionMonthlyEquivalentDuringBeta = parseFloat( this.props.accountDetails.accountState.currentPlan.metadata[ "monthlyEquivalentDuringBeta" ] );

			if ( config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.isBeta === true && subscriptionMonthlyEquivalentDuringBeta > subscriptionMonthlyEquivalent ) {
				return ( subscriptionMonthlyEquivalentDuringBeta / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor )
				//return (
				//    <span> / ${(subscriptionMonthlyEquivalentDuringBeta / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor).toFixed(5) }</span>
				//);
			}
			return subscriptionMonthlyEquivalent / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor;
			//return (
			//    <span> / ${(subscriptionMonthlyEquivalent / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor).toFixed(5) }</span>
			//);

		}


	}
	export var UserDetails = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { accountDetails: reduxStoreState.accountDetails }; //map accountDetails to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _UserDetails ) as typeof commonComponents._GenericJsxComponent;




	class _CurrentPlan extends React.Component<reduxScafolding.Action & { accountDetails: reduxScafolding.ReduxState } & { pushPath: typeof ReduxSimpleRouter.pushPath }, {}>{//currentPlanId?: string; currentPlanDetails?: ioDatatypes.account.IPlan }>{

		constructor( props: any ) {
			super( props );
		}


		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error reading your current plan", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		private _render_currentPlanCost() {
			let interval_count = this.props.accountDetails.accountState.currentPlan.interval_count;
			let intervalName = this.props.accountDetails.accountState.currentPlan.interval

			let amountPerMonth = <span>${ this.props.accountDetails.accountState.currentPlan.amount / 100 } per { `every ${ interval_count } ${ intervalName }s` }</span>;
			if ( interval_count === 1 ) {
				amountPerMonth = <span>${ this.props.accountDetails.accountState.currentPlan.amount / 100 } per { intervalName }</span>;
			}
			return <span><p>Cost: <strong>{ amountPerMonth }</strong></p></span>;
		}


		private _render_dailySubscription() {

			let betaDailySubscription = parseFloat( this.props.accountDetails.accountState.currentPlan.metadata[ "monthlyEquivalentDuringBeta" ] ) / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor;
			let dailySubscription = parseFloat( this.props.accountDetails.accountState.currentPlan.metadata[ "monthlyEquivalent" ] ) / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor;

			let betaPagesPerDay = Math.round( betaDailySubscription / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage );
			let pagesPerDay = Math.round( dailySubscription / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage );

			let betaCreditBalanceJsx = <span><p>Daily Subscription: <strong>${ betaDailySubscription.toFixed( 5 ) }</strong> <em className="small text-muted">(about { __.format( betaPagesPerDay ) } pages/day) </em> </p></span>;
			let creditBalanceJsx = <span><p>Daily Subscription: <strong>${ dailySubscription.toFixed( 5 ) }</strong> <em className="small text-muted">(about { __.format( pagesPerDay ) } pages/day) </em> </p></span>;

			if ( betaPagesPerDay >= 1 ) {
				return <span><h5>During Beta</h5>{ betaCreditBalanceJsx } <h5>After Beta</h5>{ creditBalanceJsx }</span>;
			} else {
				return <span>{ creditBalanceJsx }</span>;
			}


		}
		render() {

			if ( this.props.accountDetails.accountState == null ) {
				return <pre>Requesting from server...</pre>;
			}

			return (
				<div>
					<commonComponents.EzModal ref="Modal" />

					<div className="col-md-6">
						<h4 className="card-title">Current Plan</h4>
						<div className="card-block card-text">
							<p>Plan: <strong>{ this.props.accountDetails.accountState.currentPlan.name }</strong></p>
							{ this._render_currentPlanCost() }
							{ this._render_dailySubscription() }
						</div>
					</div>

				</div>
			);
		}





	}
	export var CurrentPlan = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { accountDetails: reduxStoreState.accountDetails }; //map accountDetails to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _CurrentPlan ) as typeof commonComponents._GenericJsxComponent;



	class _BillingInfo extends React.Component<reduxScafolding.Action & { accountDetails: reduxScafolding.ReduxState } & { pushPath: typeof ReduxSimpleRouter.pushPath }, {}>{//currentPlanId?: string; currentPlanDetails?: ioDatatypes.account.IPlan }>{

		constructor( props: any ) {
			super( props );
			//this.state = { currentPlanId: null, currentPlanDetails: null, };
		}



		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error changing your card", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		private _btnChangeBilling( e: React.MouseEvent ): Promise<any> {

			return bluebird.try( () => {
				let ezCheckout = this.props.accountDetails.ezCheckout;
				let checkoutOptions: commonComponents.StripeCheckout.IStripeCheckoutOptions = {
					amount: this.props.accountDetails.accountState.currentPlan.amount,// * (1 + config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.tax),
					allowAlipay: false,
					allowAlipayReusable: false,
					allowBitcoin: false,
					allowRememberMe: false,
					billingAddressCheck: false,
					description: "Switch your default payment source",
					email: this.props.accountDetails.accountState.email,
					imageUrl: null,
					name: `Change Billing Source`,
					payButtonLabel: `Change Primary Source.  Authorize a Monthly subscription of`,
					shippingAddressCheck: false,
					zipCodeCheck: true,
				};
				return ezCheckout.showStripe( checkoutOptions );
			} )
				.then( ( stripeResolve ) => {
					//make changePrimaryBillingSource call to server
					var origin = window.location.origin;
					var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_changeBillingSource;
					let payload: ioDatatypes.account.Payload_SubmitChangeBillingSource = {
						stripeToken: stripeResolve.stripeToken,
					};


					return new Promise<void>( ( resolve, reject ) => {
						xlib.net.axios.post<ioDatatypes.account.I_BillingDetails>( target, payload )
							.then( ( response ) => {
								log.info( "_BillingInfo._btnChangeBilling.responsePayload", response.data );
								this.props.setAccountDetails( null );
								this.props.setIsAccountDetailsOutOfDate();
								return resolve();
							} )
							.catch( ( err ) => {
								log.info( "_BillingInfo._btnChangeBilling.catch", err );
								return reject( err );
								//this.openErrorModal("response from server:", err.data);
							} );
					} );
				} )
				.catch( ( err ) => {
					if ( err.message === "aborted by user" ) {
						//user canceled, so don't show a ui
					} else {
						this.openErrorModal( err );
					}
					return Promise.reject( err );
				} );
		}

		private _render_currentBillingInfo() {

			let billingDetails = this.props.accountDetails.accountState.billingDetails;

			if ( billingDetails == null ) {
				return <pre>No Billing Information on File.</pre>
			}
			let isClickInProgress = this.props.accountDetails.orderState.orderProcessingPromise.isResolved() !== true
			let addSourceBtn = ( <button className="btn btn-secondary text-small btn-sm" onClick={ this._btnChangeBilling.bind( this ) } disabled={ isClickInProgress } >
				Change
				<Loader loaded={ isClickInProgress !== true }></Loader></button>
			);

			//log.assert(false, "_render_currentBillingInfo");
			let sourceOnFile = <span><code>None</code></span>;
			if ( billingDetails.sources != null && billingDetails.sources.length > 0 ) {
				let sourceZero = billingDetails.sources[ 0 ];

				switch ( sourceZero.object ) {
					case "card":
						let cardSource: xlib.definitions.stripe.ICard = sourceZero as any;
						sourceOnFile = <span><code>Card: <strong>...{ cardSource.last4 }</strong>, <em>expires ({ cardSource.exp_month }/{ cardSource.exp_year }) </em> </code> <br />{ addSourceBtn } </span>
						break;
					default:
						sourceOnFile = <span><strong>{ sourceZero.object }</strong> <br />{ addSourceBtn }</span>
				}
			}

			let currentPlanId = this.props.accountDetails.accountState.currentPlan.id;

			let subscriptionDetails = [];
			_.forEach( billingDetails.subscriptions, ( sub, key ) => {
				//log.assert(false);
				let renewTime = moment( sub.current_period_end * 1000 );
				let renewString = renewTime.format( "MMM Do YYYY" );
				let endingDetails = <span>Renewal Date: <code>{ renewString }</code></span>;

				if ( sub.ended_at > 0 ) {
					endingDetails = <span>Ended Date: <code>{ moment( sub.ended_at * 1000 ).format( "MMM Do YYYY" ) }</code></span>
				} else if ( sub.cancel_at_period_end === true ) {
					endingDetails = <span>Ending Date: <code>{ moment( sub.current_period_end * 1000 ).format( "MMM Do YYYY" ) }</code></span>
				}
				let statusDetails = <code>{ sub.status }</code>;
				if ( sub.cancel_at_period_end === true ) {
					statusDetails = <code>canceled</code>
				}

				let subDetail = <li key={ key }>Plan: <strong>{ sub.plan.name }</strong><br />{ this._render_currentPlanCost() } <br />Status: { statusDetails }<br />{ endingDetails }</li>
				subscriptionDetails.push( subDetail );
			} );
			if ( subscriptionDetails.length == 0 ) {
				subscriptionDetails.push( <li key="none">None</li> )
			}



			let interval_count = this.props.accountDetails.accountState.currentPlan.interval_count;
			let intervalName = this.props.accountDetails.accountState.currentPlan.interval

			let amountPerMonth = <span>${ this.props.accountDetails.accountState.currentPlan.amount } per { `every ${ interval_count } ${ intervalName }s` }</span>;
			if ( interval_count === 1 ) {
				amountPerMonth = <span>${ this.props.accountDetails.accountState.currentPlan.amount } per { intervalName } <em className="small text-muted">({ this.props.accountDetails.accountState.currentPlan.currency }) </em></span>;
			}

			let delinquentData = <span></span>;
			if ( billingDetails.isDelinquent === true ) {
				delinquentData = <div className="alert alert-danger" role="alert"><strong>SUBSCRIPTION DISABLED</strong> Your last payment did not complete successfully.Please update your billing details and then re-subscribe to the desired plan.  Contact <a href="mailto:Support@PhantomJsCloud.com">Support@PhantomJsCloud.com</a> if you have any questions.</div>
			}

			return ( <span><p>Primary Source: { sourceOnFile }</p>
				{delinquentData }
				<p>Billed Subscription Details: </p><ul>{ subscriptionDetails }</ul>

			</span> );
		}

		private _render_currentPlanCost() {
			let interval_count = this.props.accountDetails.accountState.currentPlan.interval_count;
			let intervalName = this.props.accountDetails.accountState.currentPlan.interval

			let amountPerMonth = <span>${ this.props.accountDetails.accountState.currentPlan.amount / 100 } per { `every ${ interval_count } ${ intervalName }s` }</span>;
			if ( interval_count === 1 ) {
				amountPerMonth = <span>${ this.props.accountDetails.accountState.currentPlan.amount / 100 } per { intervalName }</span>;
			}
			return <span>Cost: <code>{ amountPerMonth }</code></span>;
		}

		render() {

			if ( this.props.accountDetails.accountState == null ) {
				return <div><Loader loaded={ false } /><pre>Requesting from server...</pre></div>;
			}

			return (
				<div>
					<commonComponents.EzModal ref="Modal" />

					<div className="col-sm-6">
						<h4 className="card-title">Billing Information</h4>
						<Loader loaded={ this.props.accountDetails.isAccountDetailsOutOfDate !== true } />
						<div className="card-block card-text">
							{ this._render_currentBillingInfo() }

						</div>
						<p className="small text-muted">
							Need a monthly VAT Invoice?&nbsp;
							<ReactRouter.Link to={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.statements }>Manage Invoices</ReactRouter.Link>
						</p>
					</div>

				</div>
			);

		}





	}
	export var BillingInfo = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { accountDetails: reduxStoreState.accountDetails }; //map accountDetails to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _BillingInfo ) as typeof commonComponents._GenericJsxComponent;



	class _ChangeSubscriptionPlan extends React.Component<reduxScafolding.Action & { accountDetails?: reduxScafolding.ReduxState } & { pushPath?: typeof ReduxSimpleRouter.pushPath }, { allPlans?: ioDatatypes.account.IPlan[] }>{//currentPlanId?: string; currentPlanDetails?: ioDatatypes.account.IPlan }>{

		constructor( props: any ) {
			super( props );
			this.state = { allPlans: null };
		}
		componentWillMount() {
			this._requestFromServer();
			this.props.setOrderProcessingSubscribeFunction( this._subscribeToPlan.bind( this ) );

		}

		private _requestFromServer() {
			//log.debug("_AccountDetails.componentDidMount() props", this.props);

			var origin = window.location.origin;
			var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_allSubscriptionPlans;


			return new Promise<void>( ( resolve, reject ) => {
				xlib.net.axios.post<ioDatatypes.account.IPlan[]>( target )
					.then( ( response ) => {
						var allPlans = response.data;
						//log.info("_UserDetails._requestFromServer.responsePayload", response);
						//this.props.set(accountDetails);
						this.setState( { allPlans } );
						return resolve();
					} )
					.catch( ( err ) => {
						//this.setState({ requestErrorCount: this.state.requestErrorCount + 1 });
						log.info( "_UserDetails._requestFromServer.catch", err );
						//an _requestErrorCount >=2 causes warning message to be shown, see this._showAlertMessage()
						this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
						return resolve();
					} );
			} );

			//return xlib.net.axios.post<ioDatatypes.account.IPlan[]>(target)
			//	.then((response) => {
			//		var allPlans = response.data;
			//		//log.info("_UserDetails._requestFromServer.responsePayload", response);
			//		//this.props.set(accountDetails);
			//		this.setState({ allPlans });
			//	})
			//	.catch((err: xlib.net._axiosDTs.AxiosXHR<any>) => {
			//		//this.setState({ requestErrorCount: this.state.requestErrorCount + 1 });
			//		log.info("_UserDetails._requestFromServer.catch", err);
			//		//an _requestErrorCount >=2 causes warning message to be shown, see this._showAlertMessage()
			//		this.openErrorModal("response from server:", err.data);
			//	});
		}
		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error changing your plan", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}


		private _openSubscriptionConfirmModal( planName: string, planCostText: string ): Promise<any> {

			var title = "Please confirm your Subscription choice:";
			var message = `Choose "The ${ planName } Plan"`;

			let details: string = `${ planCostText }`;




			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;

			let confirmButtonText = "Subscribe";
			if ( planName === "Free" ) {
				confirmButtonText = "Subscribe at end of Period (Cancel current Plan)";
			}

			return modal.Show( title, message, details, { confirmButtonText } );

		}

		private _render_SinglePlan( plan: ioDatatypes.account.IPlan ) {
			return <PlanChoice plan={ plan } key={ plan.id } />;
		}

		private _render_allPlans() {

			let allPlans: any[] = [];

			_.forEach( this.state.allPlans, ( plan, key ) => {

				let singlePlan = this._render_SinglePlan( plan );
				allPlans.push( singlePlan );
			} );

			return <div className="card-group">{ allPlans }</div>;
		}


		/**
		 * handler for changing user subscriptions.  multi-call safe
		 * @param newPlanId
		 * @param e
		 */
		private _subscribeToPlan( newPlanId: string, pagesPerDayText: string, costText: string ): Promise<any> {

			let checkPromise = this.props.accountDetails.orderState.orderProcessingPromise;
			if ( checkPromise.isResolved() !== true ) {
				//log.debug("_ChooseSubscription.btnSubscribeHandleClick() START REJECTED", { isPromiseResolved: this.btnSubscribeClickPromise.isResolved(), arguments, this: this });
				return Promise.reject( new Error( "btnSubscribeHandleClick already in action" ) );
			}

			//log.debug("_ChooseSubscription.btnSubscribeHandleClick() START ACCEPTED", { isPromiseResolved: this.btnSubscribeClickPromise.isResolved(), arguments, this: this });


			//determine if we need to show stripe checkout
			let billingDetails = this.props.accountDetails.accountState.billingDetails;
			let cardOnFile = false;
			if ( billingDetails != null && billingDetails.sources != null && billingDetails.sources.length > 0 ) {
				//(billingDetails.sources[0] as xlib.definitions.stripe.ICard).
				cardOnFile = true;
			}

			let newPlan = _.find( this.state.allPlans, ( plan ) => {
				if ( plan.id === newPlanId ) {
					return true;
				}
				return false;
			} );

			//log.debug({ stripeCheckout });
			let btnSubscribeClickPromise = bluebird.try( () => {

				//show a confirm purchase modal
				return this._openSubscriptionConfirmModal( newPlan.name, costText )
					.then( () => {
						//confirmed, so now try to execute subscription choice

						return bluebird.try( () => {
							//get a stripe token if needed (maybe not if user already has one)
							if ( cardOnFile != true ) {
								let ezCheckout = this.props.accountDetails.ezCheckout;
								let checkoutOptions: commonComponents.StripeCheckout.IStripeCheckoutOptions = {
									amount: newPlan.amount * ( 1 + config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.tax ),
									allowAlipay: false,
									allowAlipayReusable: false,
									allowBitcoin: false,
									allowRememberMe: false,
									billingAddressCheck: false,
									description: pagesPerDayText,
									email: this.props.accountDetails.accountState.email,
									imageUrl: null,
									name: `The ${ newPlan.name } Plan`,
									payButtonLabel: `Subscribe ${ costText }`,
									shippingAddressCheck: false,
									zipCodeCheck: true,
								};


								return ezCheckout.showStripe( checkoutOptions );
							} else {
								//card already on file, don't need a token
								return Promise.resolve( { stripeToken: null } );
							}
						} )
							.then( ( stripeResolve ) => {

								//got stripeToken (null if already have a card on file)
								log.debug( { stripeResolve } );

								//make changeSubscription call to server

								var origin = window.location.origin;
								var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_changeSubscription;
								let payload: ioDatatypes.account.Payload_SubmitChangeSubscription = {
									planId: newPlanId,
									stripeToken: stripeResolve.stripeToken,
								};
								return new Promise<void>( ( resolve, reject ) => {
									xlib.net.axios.post<ioDatatypes.account.IAccountState>( target, payload )
										.then( ( response ) => {
											log.info( "_ChooseSubscription._btnSubscribe_handleClick.responsePayload", response.data );
											let updatedAccountDetails = response.data;
											this.props.setAccountDetails( updatedAccountDetails );
											//blib.googleAnalytics("send", "event", "purchase", "subscription", "set", newPlan.amount / 100);
											return resolve();
										} )
										.catch( ( err ) => {
											//this.setState({ requestErrorCount: this.state.requestErrorCount + 1 });
											log.info( "_ChooseSubscription._btnSubscribe_handleClick.catch", err );
											//an _requestErrorCount >=2 causes warning message to be shown, see this._showAlertMessage()
											this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
											return resolve();
										} );
								} );
							} )
							.catch( ( err ) => {
								if ( err.message === "aborted by user" ) {
									//user canceled, so don't show a ui
								} else {
									this.openErrorModal( err );
								}
								return Promise.reject( err );
							} )
					}, ( errSubscriptionModalCanceled ) => {
						//user choose cancel from the modal.
						return Promise.reject( errSubscriptionModalCanceled );
					} );

			} ).finally( () => {
				//once the promise we are monitoring for resolution finishes,
				//update our props, allowing force redraw
				this.props.setIsBalanceOutOfDate();
				setTimeout( () => {
					//this.forceUpdate();
					this.props.setOrderProcessingPromise( this.props.accountDetails.orderState.orderProcessingPromise );

				} );
			} );


			this.props.setOrderProcessingPromise( btnSubscribeClickPromise ); //update our props, allowing force redraw

			return btnSubscribeClickPromise;
		}


		render() {
			let mailSubject = `[PHANTOMJSCLOUD] USER REQUEST: Bigger Subscription Plan for ${ this.props.accountDetails.accountState.email }`;
			let mailBody = `My organization requires a bigger Subscription Plan than what is shown.  We need...`;
			let mailToHref = `mailto:Support@PhantomJsCloud.com?subject=${ encodeURIComponent( mailSubject ) }&body=${ encodeURIComponent( mailBody ) }`;
			let mailHtml = <p className="">Need a <strong>bigger</strong> Subscription Plan?&nbsp; Email <a href={ mailToHref }>Support @PhantomJsCloud.com</a>.</p>

			return (

				<section id="plans">

					<h4>Change your Subscription Plan</h4>
					<p className="small text-muted">Your Subscription provides you with <em>Daily Subscription Credits</em> <u><em>that are refilled every Day</em></u>.
						A subscription offers significant cost savings for regular use of PhantomJsCloud.</p>
					<commonComponents.EzModal ref="Modal" />
					<Loader loaded={ this.state.allPlans != null }>
						<div className="col-md-12">
							{ this._render_allPlans() }
						</div>
						<div className="col-sm-12" style={ { textAlign: "right" } }>{ mailHtml }</div>
					</Loader>
				</section>
			);
		}



	}



	export var ChangeSubscriptionPlan = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { accountDetails: reduxStoreState.accountDetails }; //map accountDetails to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _ChangeSubscriptionPlan ) as typeof commonComponents._GenericJsxComponent;



	class _PlanChoice extends React.Component<{ plan: ioDatatypes.account.IPlan, key: string } & reduxScafolding.Action & { accountDetails: reduxScafolding.ReduxState } & { pushPath: typeof ReduxSimpleRouter.pushPath }, {
		/** tracks the state of THIS plan choice click.  used to display ReactLoader (spinner) for just this not sibling plan choices */
		thisChoiceClickPromise?: Promise<any>
	}>{


		constructor( props: any ) {
			super( props );
			this.state = { thisChoiceClickPromise: null };
		}

		private _render_planInterval() {
			let interval_count = this.props.plan.interval_count;
			let intervalName = this.props.plan.interval

			let intervalDescription = <span>{ `every ${ interval_count } ${ intervalName }s` }</span>;
			if ( interval_count === 1 ) {
				intervalDescription = <span>{ intervalName }</span>;
			}
			return intervalDescription;//<span><p>Cost: <strong>{intervalDescription}</strong></p></span>;
		}

		private _render_pagesPerDay() {
			let plan = this.props.plan;

			let betaDailySubscription = parseFloat( plan.metadata[ "monthlyEquivalentDuringBeta" ] ) / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor;
			let dailySubscription = parseFloat( plan.metadata[ "monthlyEquivalent" ] ) / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor;

			let betaPagesPerDay = __.format( Math.round( betaDailySubscription / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage ) );
			let pagesPerDay = __.format( Math.round( dailySubscription / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage ) );

			//let betaCreditBalanceJsx = <span>About <strong>{betaPagesPerDay}</strong><br/>Pages/day)</span>;


			let currentPagesPerDay = betaDailySubscription > 0 ? betaPagesPerDay : pagesPerDay;
			let currentDailySubscription = betaDailySubscription >= 0 ? betaDailySubscription : dailySubscription;
			if ( config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.isBeta !== true ) {
				currentPagesPerDay = pagesPerDay;
				currentDailySubscription = dailySubscription;
			}
			//{this.props.plan.name + " Plan Details"}
			//<strong>Daily Subscription</strong>: { currentDailySubscription.toFixed(2) } Credits(About {currentPagesPerDay } Pages)
			//	< br /><em className="text-muted small">1 </em>


			let Popover = ReactBootstrap.Popover;
			let OverlayTrigger = ReactBootstrap.OverlayTrigger;


			let detailsPopover = <OverlayTrigger trigger="click" placement="right"
				overlay={
					<Popover title="Plan Details" id={ this.props.plan.name }>
						<p>The { this.props.plan.name } Plan provides a Daily Subscription of <strong>{ currentDailySubscription.toFixed( 2 ) }</strong> Credits.
							Using an average Page Cost of 2 seconds and 50Kb, this equals <strong>{ currentPagesPerDay }</strong> Pages/Day.
							If each page you request takes more time/data, then you will get fewer than { currentPagesPerDay } Pages/Day.
							If your pages take less time/data, then you will get more than { currentPagesPerDay } Pages/Day.</p>
						<p>Daily Subscription Credit incrementally refills every hour based on your active Subscription Plan.
						If your "Daily Subscription Credits" Balance reaches zero your Prepaid Credit is used.
							All requests are billed based on processing time ({ config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.pricePerHour } Credits/Hour) and Data Egress ({ config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.pricePerGb } Credits/GB) </p>
					</Popover>
				}>
				<button className="btn btn-sm btn-info-outline"><strong>?</strong></button>
			</OverlayTrigger>

			//let detailsPopover = <ReactBootstrap.Popover type="button" className="btn btn-sm btn-info-outline" data-toggle="popover" title="what" data-content="such amazing"><strong>?</strong></ReactBootstrap.Popover>




			if ( betaDailySubscription > 0 && config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.isBeta === true ) {
				let betaCreditBalanceJsx = <span>About <strong>{ betaPagesPerDay }</strong><br />Pages/Day During Beta { detailsPopover }<br /><em className="small text-muted">{ pagesPerDay } Pages/Day after Beta.</em></span>
				return betaCreditBalanceJsx;
			} else {
				let creditBalanceJsx = <span>About <strong>{ pagesPerDay }</strong><br />Pages/Day { detailsPopover }</span>
				return creditBalanceJsx;
			}
		}

		private _render_selectPlanButton() {
			let plan = this.props.plan;
			let subscribedPlanId = this.props.accountDetails.accountState.billingDetails.subscribedPlanId;
			if ( this.props.plan.id === subscribedPlanId ) {
				return <a href="https://dashboard.phantomjscloud.com/dash.html/signup.html?plan=free" rel="nofollow" className="btn btn-secondary disabled" role="button"><div className="small">Current Plan</div></a>
			}
			let isClickInProgress = this.props.accountDetails.orderState.orderProcessingPromise.isResolved() !== true


			let subscribeButtonText = <span>Subscribe</span>;
			if ( plan.name === "Free" ) {
				subscribeButtonText = <span className="small">Cancel current Plan<br />at Period End</span>;
			}


			return <button className="btn btn-primary" onClick={ this._btnSubscribe_handleClick.bind( this ) } disabled={ isClickInProgress } ><strong>{ subscribeButtonText }</strong><Loader loaded={ isClickInProgress !== true || this.state.thisChoiceClickPromise != this.props.accountDetails.orderState.orderProcessingPromise }></Loader></button>
			//return <a href="https://dashboard.phantomjscloud.com/dash.html/signup.html?plan=free" rel="nofollow" className="btn btn-primary" role="button"><div className="small">Subscribe</div></a>

		}

		private _text_pagesPerDay(): string {
			let plan = this.props.plan;
			let dailySubscription = parseFloat( plan.metadata[ "monthlyEquivalent" ] ) / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.creditsPerDayDivisor;
			let pagesPerDay = __.format( Math.round( dailySubscription / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage ) );
			return `About ${ pagesPerDay } Pages/Day`;
		}

		private _text_cost(): string {
			let interval_count = this.props.plan.interval_count;
			let intervalName = this.props.plan.interval;
			let amount = this.props.plan.amount / 100;

			if ( interval_count === 1 ) {
				return `$${ amount } per ${ intervalName }`;
			}
			return `$${ amount } per ${ interval_count } ${ intervalName }s`;
		}

		private _btnSubscribe_handleClick( e: React.MouseEvent ) {


			if ( this.props.accountDetails.orderState.orderProcessingPromise.isResolved() !== true ) {
				//still pending
				//log.debug("_PlanChoice._btnSubscribe_handleClick() START REJECT", { planId: this.props.plan.id, isPromiseResolved: this.props.btnSubscribeHook.btnSubscribeClickPromise.isResolved(), arguments, this: this });

				return;
			}
			//log.debug("_PlanChoice._btnSubscribe_handleClick() START ACCEPT", { planId: this.props.plan.id, isPromiseResolved: this.props.btnSubscribeHook.btnSubscribeClickPromise.isResolved(), arguments, this: this });


			let plan = this.props.plan;

			let planId = plan.id;
			let pagesPerDayText = this._text_pagesPerDay();
			let costText = this._text_cost();
			//this._btnSubscribe_handleClick_promise =
			let promiseResult = this.props.accountDetails.orderState.subscribeToPlan( planId, pagesPerDayText, costText )
			//.then(() => {
			//	setTimeout(() => {
			//		//log.debug("_PlanChoice._btnSubscribe_handleClick() PROMISE FINISH", { planId: this.props.plan.id, isPromiseResolved: this.props.btnSubscribeHook.btnSubscribeClickPromise.isResolved(), arguments, this: this });
			//		//this.forceUpdate();
			//	});
			//});

			//log.debug("_PlanChoice._btnSubscribe_handleClick() START FINISH", { planId: this.props.plan.id, isPromiseResolved: this.props.btnSubscribeHook.btnSubscribeClickPromise.isResolved(), arguments, this: this });

			//e.preventDefault(); //prevent browser default action of submitting
			//log.debug({ e, arguments });
			this.setState( { thisChoiceClickPromise: promiseResult } );
		}


		render() {
			if ( this.props.accountDetails.accountState == null ) {
				return <pre>Requesting from server...</pre>;
			}
			//if (true === true) {
			//    log.debug(this.props);
			//    return <span>{__.JSONX.inspectStringify(this.props) }</span>
			//}
			//            <span>{__.JSONX.inspectStringify(this.props.plan.name) }</span>
			log.debug( this.props );
			let plan = this.props.plan;
			let activePlanId = this.props.accountDetails.accountState.creditBalanceDetails.activePlanId;
			//if (this.props.accountDetails.accountState.billingDetails.subscriptions != null) {
			//    _.forEach(this.props.accountDetails.accountState.billingDetails.subscriptions, (subscription) => {
			//        switch (subscription.status){
			//            case "active":
			//            case "trialing":
			//                subscribedPlanId = subscription.plan.id;
			//                return false;
			//            default:
			//                return;
			//        }
			//    });
			//}
			return (
				<div className="card">
					<div className="card-block text-xs-center">
						<h4>The <strong><em>{ plan.name }</em></strong> Plan</h4>
						<h3 className="text-muted">${ ( plan.amount / 100 ) }</h3>
						<h5 className="text-muted">per { this._render_planInterval() }</h5>
						{ this._render_selectPlanButton() }
						<p>{ this._render_pagesPerDay() }</p>
					</div>
				</div>
			);
		}

	}

	class IPlanChoice extends React.Component<{ plan: ioDatatypes.account.IPlan, key: string }, {}> { };

	export var PlanChoice = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { accountDetails: reduxStoreState.accountDetails }; //map accountDetails to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _PlanChoice ) as any as typeof IPlanChoice;//React.Component<{ plan: ioDatatypes.account.IPlan }, {}>;


	//  let getAutoAdd_ezEndpointFunction = new xlib.net.EzEndpoint<void, ioDatatypes.account.IAutoAddState>(window.location.origin, config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_getAutoAdd, undefined, undefined,
	//  	( err ) => err.status <= 499 ? Promise.reject( new xlib.exception.HttpStatusCodeException( `unable to query status: ${ __.JSONX.inspectStringify( err.data ) }`, new Error( __.JSONX.inspectStringify( err.data ) ), err.status ) ) : null );	
	let getAutoAdd_ezEndpointFunction = new xlib.net.EzEndpoint<void, ioDatatypes.account.IAutoAddState>( {
		origin: window.location.origin,
		path: config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_getAutoAdd,

	},
		undefined,
		undefined,
		( err ) => err?.response?.status <= 499 ? bluebird.reject( new xlib.exception.HttpStatusCodeException( `unable to query status: ${ __.JSONX.inspectStringify( err.response?.data ) }`, err.response?.status, new Error( __.JSONX.inspectStringify( err.response?.data ) ) ) ) : null );

	// let setAutoAdd_ezEndpointFunction = new xlib.net.EzEndpointFunction<ioDatatypes.account.Payload_SetAutoAdd, ioDatatypes.account.IAutoAddState>(window.location.origin,
	// 	config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_setAutoAdd, undefined, undefined,
	// 	(err) => {
	// 		if (err.status <= 499) {
	// 			//console.assert(false, "err");
	// 			return Promise.reject(new xlib.exception.HttpStatusCodeException(`unable to set status: ${__.JSONX.inspectStringify(err.data)}`, new Error(__.JSONX.inspectStringify(err.data)), err.status));
	// 		} else {
	// 			return null;
	// 		}
	// 	});
	let setAutoAdd_ezEndpointFunction = new xlib.net.EzEndpoint<ioDatatypes.account.Payload_SetAutoAdd, ioDatatypes.account.IAutoAddState>( { origin: window.location.origin, path: config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_setAutoAdd }, undefined, undefined,
		( err ) => {
			if ( err.response?.status <= 499 ) {
				//console.assert(false, "err");
				//keep the reply body: the caller's catch shows err.data, so a card decline (402) shows the processor's message
				return Promise.reject( Object.assign( new xlib.exception.HttpStatusCodeException( `unable to set status: ${ __.JSONX.inspectStringify( err.response.data ) }`, err.response.status, new Error( __.JSONX.inspectStringify( err.response.data ) ) ), { data: err.response.data } ) );
			} else {
				return null;
			}
		} );


	class _AddPrepaidCredit extends React.Component<
		reduxScafolding.Action & { prepaidChoices: number[], accountDetails?: reduxScafolding.ReduxState; pushPath?: typeof ReduxSimpleRouter.pushPath }
		, {
			/** tracks the state of THIS plan choice click.  used to display ReactLoader (spinner) for just this not sibling plan choices */
			thisChoiceClickPromise?: Promise<any>;
			/** tracks the state of THIS plan choice click.  used to display ReactLoader (spinner) for just this not sibling plan choices */
			thisChoiceClickAmount?: number;
			autoAddState?: ioDatatypes.account.IAutoAddState;
			autoAddRequestPromise?: bluebird<any>;
		}
	>{

		constructor( props: any ) {
			super( props );
			this.state = { thisChoiceClickPromise: null, autoAddState: { isEnabled: false, isLastPrepaidAddFailed: false, isOffAfterFailedPayment: false }, autoAddRequestPromise: bluebird.resolve( false ) };
		}
		componentWillMount() {

			let autoAddRequestPromise = getAutoAdd_ezEndpointFunction.post()
				.then( ( response ) => {
					let autoAddState = response.data;

					this.setState( { autoAddState } );

				} ).finally( () => {
					setTimeout( () => {
						this.forceUpdate();
					} );
				} )

			this.setState( { autoAddRequestPromise } );
			//this._requestFromServer();
			//this.props.setOrderProcessingSubscribeFunction(this._subscribeToPlan.bind(this));

		}


		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error making purchase", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}


		private _openPurchaseConfirmModal( amountText: string ): Promise<any> {

			var title = "Please confirm your Purchase choice:";
			var message = `Add Prepaid Credit`;

			let details: string = `${ amountText }`;




			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;

			return modal.Show( title, message, details, { confirmButtonText: "Purchase" } );

		}


		private _render_allPaymentChoices() {



			let isClickInProgress = this.props.accountDetails.orderState.orderProcessingPromise.isResolved() !== true

			let allChoices: any[] = [];
			_.forEach( this.props.prepaidChoices, ( amount, key ) => {
				let costText = `Add $${ amount }`;
				let pagesPerDayText = `About ${ __.format( amount / config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.estimatedPricePerPage ) } Pages`;
				let singleChoice = (
					<div key={ key }>
						<div className="col-lg-6">
							<br />
							<button className="btn btn-primary btn-block" onClick={ this._btnMakePurchase_Click.bind( this, amount, pagesPerDayText, costText ) } disabled={ isClickInProgress } >
								<strong>{ costText }</strong><br /><em className="small">{ pagesPerDayText }</em>
								<Loader loaded={ isClickInProgress !== true || this.state.thisChoiceClickPromise != this.props.accountDetails.orderState.orderProcessingPromise || this.state.thisChoiceClickAmount != amount }></Loader></button>
						</div>
					</div>
				);
				allChoices.push( singleChoice );
			} );

			return <span>{ allChoices }</span>;
		}


		/**
		 * handler for changing user subscriptions.  multi-call safe
		 * @param newPlanId
		 * @param e
		 */
		private _btnMakePurchase_Click( purchaseAmount: number, pagesPerDayText: string, costText: string, e: React.MouseEvent ): Promise<any> {

			let checkPromise = this.props.accountDetails.orderState.orderProcessingPromise;
			if ( checkPromise.isResolved() !== true ) {
				return Promise.reject( new Error( "order already in action" ) );
			}

			//determine if we need to show stripe checkout
			//let billingDetails = this.props.accountDetails.accountState.billingDetails;
			let isBillingValid = this.props.accountDetails.accountState.billingDetails.isBillingValid;


			let btnMakePurchase_Promise = bluebird.try( () => {

				//show a confirm purchase modal
				return this._openPurchaseConfirmModal( costText )
					.then( () => {
						//confirmed, so now try to execute subscription choice
						log.info( "cost text", { costText } );
						return bluebird.try( () => {
							//get a stripe token if needed (maybe not if user already has one)
							if ( isBillingValid != true ) {
								let ezCheckout = this.props.accountDetails.ezCheckout;
								let checkoutOptions: commonComponents.StripeCheckout.IStripeCheckoutOptions = {
									amount: purchaseAmount * 100,// * (1 + config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.tax),
									allowAlipay: false,
									allowAlipayReusable: false,
									allowBitcoin: false,
									allowRememberMe: false,
									billingAddressCheck: false,
									description: pagesPerDayText,
									email: this.props.accountDetails.accountState.email,
									imageUrl: null,
									name: `Prepaid Credit`,
									payButtonLabel: `${ costText } in Prepaid Credit`,
									shippingAddressCheck: false,
									zipCodeCheck: true,
								};


								return ezCheckout.showStripe( checkoutOptions );
							} else {
								//card already on file, don't need a token
								return Promise.resolve( { stripeToken: null } );
							}
						} )
							.then( ( stripeResolve ) => {
								//got stripeToken (null if already have a card on file)

								//make changeSubscription call to server
								var origin = window.location.origin;
								var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_purchasePrepaidCredit;
								let payload: ioDatatypes.account.Payload_SubmitPurchasePrepaidCredit = {
									purchaseAmount: purchaseAmount,
									stripeToken: stripeResolve.stripeToken,
								};
								return new Promise<void>( ( resolve, reject ) => {
									xlib.net.axios.post<config.pjscGlobalConfig.sharedConfig.balance.IBalance>( target, payload )
										.then( ( response ) => {
											log.info( "_ChooseSubscription._btnSubscribe_handleClick.responsePayload", response.data );
											let updatedBalance = response.data;
											this.props.setBalance( updatedBalance );
											return resolve();
										} )
										.catch( ( err ) => {
											log.info( "_ChooseSubscription._btnSubscribe_handleClick.catch", err );
											return reject( err );
											//this.openErrorModal("response from server:", err.data);
										} )
								} ).then( () => {
									//blib.googleAnalytics("send", "event", "purchase", "prepaid", "add", purchaseAmount);
									return Promise.resolve();
								} );
							} )
							.catch( ( err ) => {
								if ( err.message === "aborted by user" ) {
									//user canceled, so don't show a ui
								} else {
									//this.openErrorModal(err);
									if ( err.data != null ) {
										this.openErrorModal( "response from server:", err.data );
									} else {
										this.openErrorModal( err );
									}
								}
								return Promise.reject( err );
							} )
					}, ( errSubscriptionModalCanceled ) => {
						//user choose cancel from the modal.
						return Promise.reject( errSubscriptionModalCanceled );
					} );

			} ).finally( () => {
				if ( isBillingValid !== true ) {
					//billing wasn't valid before, so need to update our billing details with new stripe info
					this.props.setIsAccountDetailsOutOfDate();

				}

				//once the promise we are monitoring for resolution finishes,

				setTimeout( () => {

					//update our props, allowing force redraw
					this.props.setOrderProcessingPromise( this.props.accountDetails.orderState.orderProcessingPromise ); //btnMakePurchase_Promise

				} );
			} );
			//btnMakePurchase_Promise.finally(() => {
			//});


			this.props.setOrderProcessingPromise( btnMakePurchase_Promise ); //update our props, allowing force redraw
			this.setState( { thisChoiceClickPromise: btnMakePurchase_Promise, thisChoiceClickAmount: purchaseAmount } );
			return btnMakePurchase_Promise;
		}


		render() {

			let RBInput = ReactBootstrap.Input
			//<div className="card card-block">
			//	<div className="col-xs-1">X</div><div className="col-xs-11">bla</div>

			//</div>

			//<label>
			//	<input type="checkbox"
			//		checked={this.state.checked}
			//		onChange={this.handleClick.bind(this)}
			//		/>
			//		MyCheckbox!
			//</label>

			return (

				<div className="col-sm-6" id="purchasePrepaidCredit">
					<commonComponents.EzModal ref="Modal" />


					<h4>Add Prepaid Credit</h4>
					<p className="small text-muted">Prepaid Credit offers the best flexibility for sudden "burst" use of PhantomJsCloud.  If you have more regular usage patterns, consider a Subscription Plan.</p>
					<div className="row">
						<div className="col-sm-12">
							{ this._render_allPaymentChoices() }
						</div>
					</div>

					<br />
					{this._render_AutoAdd() }



				</div>
			);
		}

		private _render_AutoAdd() {

			return (
				<div className="row">
					<div className="col-sm-12">
						<label>
							<input type="checkbox"
								style={ { width: "20px", height: "20px", } }
								checked={ this.state.autoAddState.isEnabled }
								onChange={ this._autoAdd_click.bind( this ) }
							/>
							Automatically Add $20 when Prepaid Credit is under $1
							<Loader loaded={ this.state.autoAddRequestPromise.isResolved() === true } />
							<p className="small text-muted">If your bank denies an auto-add payment, we retry on your next request after a 25 minute wait.</p>
						</label>
					</div>
					{this._render_AutoAddDisabledNotify() }
				</div>
			);
		}

		private _render_AutoAddDisabledNotify() {
			if ( this.state.autoAddState.isEnabled !== true ) {
				//off after a failed refill: the 25-minute text no longer holds (PjscDashboardApp #202610241240_1)
				if ( this.state.autoAddState.isOffAfterFailedPayment !== true ) {
					return null;
				}
				return (
					<div className="alert alert-danger">
						<div className="label label-danger">AUTOADD OFF</div>
						<div>Auto-Add is off. Your last auto-add payment failed (<strong>Billing failed</strong>). Check your card or add Prepaid Credits, then turn Auto-Add on again. If this keeps happening, contact <a href={ "mailto:" + SUPPORT_EMAIL }>{ SUPPORT_EMAIL }</a>.</div>
					</div>
				);
			}
			if ( this.state.autoAddState.isLastPrepaidAddFailed !== true ) {
				return null;
			}
			return (
				<div className="alert alert-danger">
					<div className="label label-danger">AUTOADD FAILED</div>
					<div>Auto-Add is disabled for 25 minutes because we were not able to charge your account (<strong>Billing failed</strong>). Please either wait and retry again, or manually add Prepaid Credits <em>then <a href=".">reload this page</a></em> to re-enable Auto-Add.</div>
				</div>
			);
		}

		_autoAdd_click( e: React.FormEvent ) {

			if ( this.state.autoAddRequestPromise.isResolved() !== true ) {
				e.preventDefault();
				return;
			}

			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			let isAutoAddEnabled = e.target[ "checked" ] as boolean;

			let needsAccountRefresh = false;


			return bluebird.try( () => {
				//show confirm dialogue

				let title = ( <div>Disable Auto-Add $20?</div> );
				let message = ( <div>If you choose <strong>Yes</strong> your <strong>Prepaid Credit</strong> will not automatically refill when it is under $1.</div> );
				if ( isAutoAddEnabled === false ) {
					return modal.Show( title, message, null, { confirmButtonText: "Yes" } )
						.then( () => {
							//log.info("todo");
							//this.setState({ isAutoAddEnabled: enableAutoAdd });
						} )
				} else {
					let title = ( <div>Enable Auto-Add $20?</div> );
					let message = ( <div>
						<p>Choose <strong>Yes</strong> to automatically purchase $20 when <strong>Prepaid Credit</strong> is under $1.</p>
						<p className="small">If you sometimes use more than your Daily Subscription amount, enabling Auto-Add will make sure your requests will never fail due to running out of credits.</p>
					</div> );
					// = (<div></div>);
					return modal.Show( title, message, null, { confirmButtonText: "Yes" } )
						.then( () => {
							//log.info("todo");
							//this.setState({ isAutoAddEnabled: enableAutoAdd });
						} )
				}
			} )
				.then( () => {

					let isBillingValid = this.props.accountDetails.accountState.billingDetails.isBillingValid;
					//get a stripe token if needed (maybe not if user already has one)
					if ( isBillingValid != true && isAutoAddEnabled === true ) {
						let ezCheckout = this.props.accountDetails.ezCheckout;
						let checkoutOptions: commonComponents.StripeCheckout.IStripeCheckoutOptions = {
							amount: 20 * 100,// * (1 + config.pjscGlobalConfig.sharedConfig.BILLING_CONSTANTS.tax),
							allowAlipay: false,
							allowAlipayReusable: false,
							allowBitcoin: false,
							allowRememberMe: false,
							billingAddressCheck: false,
							description: "Auto-Add Prepaid Credit",
							email: this.props.accountDetails.accountState.email,
							imageUrl: null,
							name: `Add Billing Details`,
							payButtonLabel: `When under $1 add`,
							shippingAddressCheck: false,
							zipCodeCheck: true,
						};

						needsAccountRefresh = true;
						return ezCheckout.showStripe( checkoutOptions );
					} else {
						//card already on file or we are disabling auto-add, don't need a token
						return Promise.resolve( { stripeToken: null } );
					}
				} )
				.then( ( { stripeToken } ) => {
					//got stripeToken (null if already have a card on file)

					//do api request
					let payload: ioDatatypes.account.Payload_SetAutoAdd = { isAutoAddEnabled, stripeToken };
					//window.location.origin
					let autoAddRequestPromise = setAutoAdd_ezEndpointFunction.post( payload )
						.then( ( response ) => {
							log.info( "_AddPrepaidCredit.handleClick.responsePayload", response.data );
							this.setState( { autoAddState: response.data } );

							//blib.googleAnalytics("ecommerce:addTransaction", {
							//	id: this.props.accountDetails.accountState.email + "_" + __.utcNow().toISOString()
							//	name:"AutoAdd20"
							//});
						} ).catch( ( err ) => {
							log.info( "_AddPrepaidCredit.handleClick.catch", err );

							if ( err.data != null ) {
								this.openErrorModal( "response from server:", err.data );
							} else {
								this.openErrorModal( err );
							}

							return Promise.reject( err );
						} )
						.finally( () => {
							setTimeout( () => {
								this.forceUpdate();
							} );
						} );



					this.setState( { autoAddRequestPromise } );
					return autoAddRequestPromise;
				} )
				.then( () => {

					//if (isAutoAddEnabled === true) {
					//	if (this.props.accountDetails.balance.prepaidBalance < 1) {
					//		//blib.googleAnalytics("send", "event", "purchase", "prepaid", "autoAdd", 20);
					//	} else {
					//		//blib.googleAnalytics("send", "event", "purchase", "prepaid", "autoAdd", 0);
					//	}
					//}

					//update our credit blaance
					if ( needsAccountRefresh === true ) {
						this.props.setIsAccountDetailsOutOfDate();
					}
					this.props.setIsBalanceOutOfDate();


				} )






			//return modal.Show(title, message, details, { confirmButtonText: "Purchase" });


			//e.preventDefault(); //prevent browser default action of submitting
			//log.debug("_AddPrepaidCredit.handleClick()", { newValue, isAutoAddChecked: this.state.isAutoAddEnabled });//, e, target: e.target });
			//this.setState({ isAutoAddEnabled: newValue });
		}

	}
	class IAddPrepaidCredit extends React.Component<{ prepaidChoices: number[] }, {}> { };
	export var AddPrepaidCredit = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { accountDetails: reduxStoreState.accountDetails }; //map accountDetails to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _AddPrepaidCredit ) as any as typeof IAddPrepaidCredit;

	class _AccountDetails extends commonComponents.ReactRouterComponent<reduxScafolding.Action & { accountDetails: reduxScafolding.ReduxState } & { pushPath: typeof ReduxSimpleRouter.pushPath }, { requestErrorCount?: number }>{
		constructor( props: any ) {
			super( props );
			this.state = { requestErrorCount: 0 };

		}
		componentWillMount() {
			//send page hit
			blib.ga_ezSpaPageHit();

			////send account details event
			//blib.googleAnalytics("send", "event", "accountDetails", "view");
		}

		componentDidMount() {

			this._requestFromServer();

			let ezCheckout = this.refs[ "ezCheckout" ] as commonComponents.StripeCheckout.EzStripeCheckout;
			this.props.setEzCheckout( ezCheckout );


			//log.info("_AccountDetails.componentDidMount", { accountState: this.props.accountDetails.accountState });
		}

		private _requestFromServer() {
			//this.openErrorModal("testing error modal", {hi:"there"});
			//log.debug("_AccountDetails.componentDidMount() props", this.props);

			var origin = window.location.origin;
			var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.account_accountDetails;
			return new Promise<void>( ( resolve, reject ) => {
				xlib.net.axios.post<ioDatatypes.account.IAccountState>( target )
					.then( ( response ) => {
						var accountDetails = response.data;
						//log.info("_UserDetails._requestFromServer.responsePayload", response);
						this.props.setAccountDetails( accountDetails );
						this.setState( { requestErrorCount: 0 } );
						return resolve();
					} )
					.catch( ( err ) => {
						//this.setState({ requestErrorCount: this.state.requestErrorCount + 1 });
						log.info( "_UserDetails._requestFromServer.catch", err );
						//an _requestErrorCount >=2 causes warning message to be shown, see this._showAlertMessage()
						this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
						return resolve();
					} );
			} );
		}

		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error reading account details", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		//private _showAlertMessage() {


		//    if (this.state.requestErrorCount < 2) {
		//        return;
		//    } else {
		//        return (

		//            <div className="alert alert-danger">Unable to connect to server in last {this.state.requestErrorCount * this._requestIntervalSeconds} seconds.Balance not updated.</div>

		//        );
		//    }
		//}

		componentWillReceiveProps( nextProps: any ) {
			if ( nextProps.accountDetails.isAccountDetailsOutOfDate === true ) {
				this._requestFromServer();
			}
		}

		render() {


			return (
				<section>
					<commonComponents.EzModal ref="Modal" />
					<commonComponents.StripeCheckout.EzStripeCheckout ref="ezCheckout" configOptions={ { stripeKey: config.STRIPE_PUBLIC_KEY } } />
					<login.components.LoginStatusMonitor logedOutRedirect={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.root } />
					<Loader loaded={ this.props.accountDetails.accountState != null }>
						<div>




							<div className="row">
								<UserDetails />
							</div>
							<hr />
							<div className="row">
								<BillingInfo />
								<AddPrepaidCredit prepaidChoices={ [ 20, 100 ] } />
							</div>
							<hr />
							<div className="row">
								<ChangeSubscriptionPlan />
							</div>





							{
								this.props.children //render the child route component, if any
							}
						</div>
					</Loader>
					<div>
						Need a <strong>Private Cloud + SLA</strong>?&nbsp; Check out the new <a className="nav-link nav-item" target="_blank" href={ config.pjscGlobalConfig.sharedConfig.domains.www.origin + "/enterprise.html" }><strong>Enterprise Features</strong></a> Page.
					</div>
				</section>
			);

		}

		onToken( token: string ) {
			log.debug( "AccountDetails.onToken()", { token, arguments } );

			//this.componentDidMount
		}
	}
	export var AccountDetails = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { accountDetails: reduxStoreState.accountDetails }; //map accountDetails to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _AccountDetails ) as typeof commonComponents._GenericJsxComponent;

}
